import {customEvent} from "../../webpack/modules/events";
import {hideElement, showElement} from "../../webpack/modules/element-visibility";

customEvent('show.bs.offcanvas', '.offcanvas', false, function() {
    let chatWidget = document.querySelector('.chatwithapp');
    if (chatWidget) hideElement(chatWidget);
    let tawkWidgets = document.querySelectorAll('.widget-visible iframe');
    if (tawkWidgets) {
        tawkWidgets.forEach(function (widget, index) {
            if (index === 0 || index === 4) hideElement(widget);
        });
    }
});

customEvent('hidden.bs.offcanvas', '.offcanvas', false, function() {
    let chatWidget = document.querySelector('.chatwithapp');
    if (chatWidget) showElement(chatWidget);
    let tawkWidgets = document.querySelectorAll('.widget-visible iframe');
    if (tawkWidgets) {
        tawkWidgets.forEach(function (widget, index) {
            if (index === 0 || index === 4) showElement(widget);
        });
    }
});